const DOMAIN_NAME = {
  //URL_EASYMOCK: 'http://zeqiao.xueqiusoft.com',
  URL_EASYMOCK: 'https://api.zq-doctor.com',
  ZQ_API: 'https://new.med-video.com/api',
}

export default DOMAIN_NAME



// WEBPACK FOOTER //
// ./src/server/config.js